import { Component, OnInit } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Pagina } from '../shared/model/pagina.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pagina',
  templateUrl: './pagina.component.html',
  styleUrls: ['./pagina.component.css']
})
export class PaginaComponent implements OnInit {

  public pagina: Pagina;
  public conteudo: string;

  constructor(private service: CMSPortalService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.getPagina(params['id']);
    });
  }

  getPagina(idPagina: string) {
    this.service.getPagina(idPagina).subscribe(res => {
      this.pagina = res.conteudo;
      this.conteudo = this.pagina.conteudo;
    });
  }

}
